import { render, staticRenderFns } from "./CongelationInvoice.vue?vue&type=template&id=02861e78&"
import script from "./CongelationInvoice.vue?vue&type=script&lang=js&"
export * from "./CongelationInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports